import { InfillTypes } from './infill-types';

// Single registry of laser-cut infill designs. The picker, quote labels and the
// PDF style table are all generated from this list — adding a design here (plus
// its InfillTypes/ProductTypes entries, icons and a backend product) is enough.
export interface ILaserCutDesign {
  key: string;        // InfillTypes member; stored in project/railing params
  label: string;      // marketing name shown on the picker tile
  quoteName: string;  // style name used in quote form and PDF ('Laser Cut ' + quoteName)
  icon: string;
  iconOn: string;
}

const ICONS = '/assets/images/3_RailingTab/06_InfillType/laser-cut/';

export const LASER_CUT_DESIGNS: ILaserCutDesign[] = [
  {
    key: InfillTypes.laserCutPisces,
    label: 'Pisces',
    quoteName: 'Pisces',
    icon: ICONS + 'VT_icons_pisces.png',
    iconOn: ICONS + 'VT_icons_pisces_on.png'
  },
  {
    key: InfillTypes.laserCutRhythm,
    label: 'Torrent',
    quoteName: 'Rhythm',
    icon: ICONS + 'VT_icons_rhythm.png',
    iconOn: ICONS + 'VT_icons_rhythm_on.png'
  },
  {
    key: InfillTypes.laserCutAgama,
    label: 'Agama',
    quoteName: 'Agama',
    icon: ICONS + 'VT_icons_agama.png',
    iconOn: ICONS + 'VT_icons_agama_on.png'
  },
  {
    key: InfillTypes.laserCutTrillium,
    label: 'Trillium',
    quoteName: 'Trillium',
    icon: ICONS + 'VT_icons_trillium.png',
    iconOn: ICONS + 'VT_icons_trillium_on.png'
  },
  {
    key: InfillTypes.laserCutPulse,
    label: 'Cypher',
    quoteName: 'Cypher',
    icon: ICONS + 'VT_icons_pulse.png',
    iconOn: ICONS + 'VT_icons_pulse_on.png'
  },
  {
    key: InfillTypes.laserCutCubist,
    label: 'Cubist',
    quoteName: 'Cubist',
    icon: ICONS + 'VT_icons_cubist.png',
    iconOn: ICONS + 'VT_icons_cubist_on.png'
  },
  {
    key: InfillTypes.laserCutSverra,
    label: 'Sverra',
    quoteName: 'Sverra',
    icon: ICONS + 'VT_icons_severa.png',
    iconOn: ICONS + 'VT_icons_severa_on.png'
  },
  {
    key: InfillTypes.laserCutSeagrass,
    label: 'Seagrass',
    quoteName: 'Sea Grass',
    icon: ICONS + 'VT_icons_seagrass.png',
    iconOn: ICONS + 'VT_icons_seagrass_on.png'
  },
  {
    key: InfillTypes.laserCutBound,
    label: 'Bound',
    quoteName: 'Sea Bound',
    icon: ICONS + 'VT_icons_bound.png',
    iconOn: ICONS + 'VT_icons_bound_on.png'
  },
  // Kerri Kelly Collection. Numbering follows the spec image left-to-right,
  // top-to-bottom: 1 diagonal chevron, 2 crosses, 3 circle lattice,
  // 4 diamond lattice, 5 dot grid, 6 vertical slots, 7 constellation,
  // 8 basket weave, 9 arches. Names are placeholders until Feeney provides the
  // official ones. 3D renders via local placeholder products
  // (laser-cut-kelly-local.config.ts) until the real 'Laser Cut Kelly N'
  // panels are published on the backend.
  {
    key: InfillTypes.laserCutKelly1,
    label: 'Kerri Kelly 1',
    quoteName: 'Kelly 1',
    icon: ICONS + 'VT_icons_kelly_1.png',
    iconOn: ICONS + 'VT_icons_kelly_1_on.png'
  },
  {
    key: InfillTypes.laserCutKelly2,
    label: 'Kerri Kelly 2',
    quoteName: 'Kelly 2',
    icon: ICONS + 'VT_icons_kelly_2.png',
    iconOn: ICONS + 'VT_icons_kelly_2_on.png'
  },
  {
    key: InfillTypes.laserCutKelly3,
    label: 'Kerri Kelly 3',
    quoteName: 'Kelly 3',
    icon: ICONS + 'VT_icons_kelly_3.png',
    iconOn: ICONS + 'VT_icons_kelly_3_on.png'
  },
  {
    key: InfillTypes.laserCutKelly4,
    label: 'Kerri Kelly 4',
    quoteName: 'Kelly 4',
    icon: ICONS + 'VT_icons_kelly_4.png',
    iconOn: ICONS + 'VT_icons_kelly_4_on.png'
  },
  {
    key: InfillTypes.laserCutKelly5,
    label: 'Kerri Kelly 5',
    quoteName: 'Kelly 5',
    icon: ICONS + 'VT_icons_kelly_5.png',
    iconOn: ICONS + 'VT_icons_kelly_5_on.png'
  },
  {
    key: InfillTypes.laserCutKelly6,
    label: 'Kerri Kelly 6',
    quoteName: 'Kelly 6',
    icon: ICONS + 'VT_icons_kelly_6.png',
    iconOn: ICONS + 'VT_icons_kelly_6_on.png'
  },
  {
    key: InfillTypes.laserCutKelly7,
    label: 'Kerri Kelly 7',
    quoteName: 'Kelly 7',
    icon: ICONS + 'VT_icons_kelly_7.png',
    iconOn: ICONS + 'VT_icons_kelly_7_on.png'
  },
  {
    key: InfillTypes.laserCutKelly8,
    label: 'Kerri Kelly 8',
    quoteName: 'Kelly 8',
    icon: ICONS + 'VT_icons_kelly_8.png',
    iconOn: ICONS + 'VT_icons_kelly_8_on.png'
  },
  {
    key: InfillTypes.laserCutKelly9,
    label: 'Kerri Kelly 9',
    quoteName: 'Kelly 9',
    icon: ICONS + 'VT_icons_kelly_9.png',
    iconOn: ICONS + 'VT_icons_kelly_9_on.png'
  }
];

export function getLaserCutDesign(key: string): ILaserCutDesign {
  return LASER_CUT_DESIGNS.find(d => d.key === key);
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/model/laser-cut-designs.config.ts